import React from 'react';
import { useViewlogies } from 'context';
import './banner.scss';
import { getCorrectedUrl } from '../../utils.js';
import DonationButton from './DonationButton';

const DonationBox = () => {
    const {
        event: { donationUrl, donationUrl2, color, firstName, lastName },
    } = useViewlogies();

    const familyNameText = lastName ? `The ${lastName} family` : 'The family';
    const personName = [firstName, lastName].filter(Boolean).join(' ') || 'the deceased';
    const headerText = `${familyNameText} would be honored by a donation`;
    const subheaderText = `in ${personName}'s name...`;

    const correctedUrl1 = getCorrectedUrl(donationUrl);
    const correctedUrl2 = getCorrectedUrl(donationUrl2);

    return (
        <>
            {(correctedUrl1 || correctedUrl2) && (
                <div className="donation-box">
                    <div className="donation-header">{headerText}</div>
                    <div className="donation-subheader">{subheaderText}</div>

                    {correctedUrl1 && <DonationButton href={correctedUrl1} label="DONATE" color={color} />}
                    {correctedUrl2 && <DonationButton href={correctedUrl2} label="DONATE 2" color={color} />}
                </div>
            )}
        </>
    );
};

export default DonationBox;
